export default "__VITE_ASSET__BV2eZwF8__"